import axios from "axios";
import {AUTH_API_URL} from "../environment";

// A dedicated instance, deliberately NOT the default axios export: the main
// app sets axios.defaults.headers.common.Authorization to the *main backend*
// access token (see authInterceptor.js). Keeping auth-service traffic on its
// own instance means it's never accidentally affected by that global default.
const authAxios = axios.create();

// Client for the standalone JWT auth-service (see /agrilive/auth-service) —
// replaces the old usr/authenticateV2 & usr/create calls, which hit endpoints
// that only ever existed on a mock server and 404 against the real backend.
class AuthService {
    register = (data) => authAxios.post(`${AUTH_API_URL}/auth/register`, data);

    login = (data) => authAxios.post(`${AUTH_API_URL}/auth/login`, data);

    // RefreshJwtStrategy (auth-service) extracts the token from the request
    // *body*, not an Authorization header — unlike every other endpoint here.
    refresh = (refreshToken) => authAxios.post(`${AUTH_API_URL}/auth/refresh`, {refreshToken});

    me = (accessToken) => authAxios.get(`${AUTH_API_URL}/me`, {
        headers: {Authorization: `Bearer ${accessToken}`},
    });

    logout = () => authAxios.post(`${AUTH_API_URL}/auth/logout`);
}

export default new AuthService();
